<template>
  <div class="p-email-item mx-5">
    <v-list class="p-email-list mt-1">
      <template v-for="(item, index) in emailItem">
        <v-list-item v-bind:key="item.id">
          <v-row>
            <v-col cols="12" sm="6" md="8" lg="9">
              <v-row class="p-row-email">
                <p-avatar
                  :email="item.from.email"
                  :char="item.from.name? item.from.name[0]: item.from.email[0]"
                  :size="40"
                  class="mb-2 mr-4"
                >
                </p-avatar>
                <div class="p-email-text">
                  <div class="font-weight-medium p-from mb-2">
                    {{item.from.name? item.from.name: item.from.email}}
                  </div>
                  <div v-if="item.to != null">
                    {{getDestinationText(item.to)}}
                  </div>
                  <div>
                    {{item.subject}}
                  </div>
                  <div class="mt-2" v-html="item.body">
                    {{item.body}}
                  </div>

                  <div v-if="item.attachments && item.attachments.length" class="p-attachments d-flex">
                    <div>
                      <v-icon class="mdi-rotate-270">mdi-attachment</v-icon>
                    </div>
                    <div>
                      <div v-for="attachment in item.attachments" :key="`attachment-${attachment.id}`">
                        <p-file-icon :extension="attachment.extension"></p-file-icon>
                        <span class="p-email-link" @click.stop="downloadFile(item.id, attachment)">{{attachment.name}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </v-row>
            </v-col>
            <v-col class="time mt-2" cols="12" sm="6" md="4" lg="3">
              {{ getTime(item.createdAt)}}
              <v-btn v-if="hasAccess()" icon @click="replyEmail(item)">
                <v-icon>mdi-reply</v-icon>
              </v-btn>
              <template v-for="user in item.readUsers">
                <v-tooltip bottom :key="user.email">
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <p-avatar
                        :key="user.email"
                        :email="user.email"
                        :char="user.name[0]"
                        :size="24"
                        class="mb-2 mx-2"
                      >
                      </p-avatar>
                    </v-btn>
                  </template>
                  <span>
                    {{ getUserInfo(user) }}
                  </span>
                </v-tooltip>
              </template>
            </v-col>
          </v-row>
        </v-list-item>
        <v-divider
          v-if="index < emailItem.length - 1"
          :key="index"
          class="mb-2"
        ></v-divider>
      </template>
    </v-list>
    <send-email-dialog
      :email="newEmail"
      :thread="thread"
      :dialog.sync="sendEmailDialog"
    ></send-email-dialog>
  </div>
</template>


<script>
import { mapGetters, mapActions } from 'vuex'

import moment from 'moment'

import fileHelper from '@/helpers/file.helper'

import PAvatar from '@/components/PAvatar'
import SendEmailDialog from './EmailSendDialog'
import PFileIcon from '@/components/PFileIcon'

import snackbarMixin from '@/mixins/snackbar.mixin'
import accessMixin from '@/mixins/access.mixin'


export default {
  components: {
    PAvatar,
    SendEmailDialog,
    PFileIcon
  },


  mixins: [
    snackbarMixin,
    accessMixin
  ],


  props: {
    emailItem: Array,
    thread: String
  },


  data () {
    return {
      dateFormat: 'YYYY-MM-DD',
      timeFormat: 'HH:mm',
      displayFormat: 'MMM D, YYYY, hh:mm A',
      newEmail: null,
      sendEmailDialog: false
    }
  },


  computed: {
    ...mapGetters('user', ['userById', 'users'])
  },


  methods: {
    ...mapActions('thread', ['getAttachment', 'getEmail']),

    async downloadFile (emailId, attachment) {
      try {
        attachment.emailId = emailId
        var response = await this.getAttachment(attachment)
        const blob = new Blob([response.data], { type: response.headers['content-type'] })
        fileHelper.downloadFile(blob, attachment.name)
      } catch (error) {
        this.showSnackbarError()
        this.$log.error(error)
      }
    },

    getTime (emailDate) {
      if (emailDate === undefined) {
        return null
      }
      return moment(emailDate).format(this.displayFormat) + ' (' + moment(emailDate).fromNow() + ')'
    },

    getUserInfo (user) {
      return user.name + ' (' + moment(user.readAtUtc).format(this.displayFormat) + ')'
    },

    async replyEmail (email) {
      try {
        const response = await this.getEmail(email.id)
        const responseEmail = response.data
        this.newEmail = {}
        this.newEmail.subject = responseEmail.subject.startsWith('Re:')
          ? responseEmail.subject : 'Re: ' + responseEmail.subject
        this.newEmail.to = []
        this.newEmail.to.push({
          contactEmail: responseEmail.from,
          displayName: responseEmail.from
        })
        this.openNewEmail()
      } catch (error) {
        this.showSnackbarError()
        this.$log.error(error)
      }
    },

    getDestinationText (destinations) {
      let destination = ''
      for (let i = 0; i < destinations.length; i++) {
        if (destination.length > 0) {
          destination += ', '
        }
        destination += destinations[i].name ? destinations[i].name
          : destinations[i].email ? destinations[i].email : destinations[i]
      }
      return destination
    },

    openNewEmail () {
      this.sendEmailDialog = true
    }
  }
}
</script>
